import { createRouter, createWebHashHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'
import type { App } from 'vue'
import { Layout } from '@/utils/routerHelper'
import { useI18n } from '@/hooks/web/useI18n'

const { t } = useI18n()

export const constantRouterMap: AppRouteRecordRaw[] = [
  {
    path: '/',
    component: Layout,
    redirect: '/products/productList',
    name: 'Root',
    meta: {
      hidden: true
    }
  },
  {
    path: '/redirect',
    component: Layout,
    name: 'Redirect',
    children: [
      {
        path: '/redirect/:path(.*)',
        name: 'RedirectPath',
        component: () => import('@/views/Redirect/Redirect.vue'),
        meta: {}
      }
    ],
    meta: {
      hidden: true,
      noTagsView: true
    }
  },
  {
    path: '/login',
    component: () => import('@/views/Login/Login.vue'),
    name: 'Login',
    meta: {
      hidden: true,
      title: t('router.login'),
      noTagsView: true
    }
  },
  {
    path: '/forgetPassword',
    component: () => import('@/views/ForgetPassword/ForgetPassword.vue'),
    name: 'forgetPassword',
    meta: {
      hidden: true,
      title: t('login.forgetPassword'),
      noTagsView: true
    }
  },
  {
    path: '/register',
    component: () => import('@/views/Register/Register.vue'),
    name: 'register',
    meta: {
      hidden: true,
      title: t('login.forgetPassword'),
      noTagsView: true
    }
  },
  {
    path: '/404',
    component: () => import('@/views/Error/404.vue'),
    name: 'NoFind',
    meta: {
      hidden: true,
      title: '404',
      noTagsView: true
    }
  }
]

export const asyncRouterMap: AppRouteRecordRaw[] = [
  {
    path: '/products',
    name: 'Products',
    component: Layout,
    redirect: '/products/productList',
    meta: {
      title: t('router.products'),
      icon: 'svgProduct'
    },
    children: [
      {
        path: 'productList',
        name: 'ProductList',
        component: () => import('@/views/Level/products/list/ProductsList.vue'),
        meta: {
          title: t('router.productList'),
          tabTitle: t('router.arProductList'),
          name: 'ProductList'
        },
        children: [
          {
            path: 'release',
            name: 'Release',
            component: () => import('@/views/Level/products/release/index.vue'),
            meta: {
              title: t('product.releaseProduct'),
              hidden: true,
              name: 'ProductList',
              noCache: true
            }
          },
          {
            path: 'createArSculpture',
            name: 'CreateArSculpture',
            component: () => import('@/views/Level/products/createArSculpture/index.vue'),
            meta: {
              title: t('product.createArSculpture'),
              hidden: true,
              name: 'ProductList',
              noCache: true
            }
          },
          {
            path: 'createArDrawings',
            name: 'CreateArDrawings',
            component: () => import('@/views/Level/products/createArDrawings/index.vue'),
            meta: {
              title: t('product.createArDrawings'),
              hidden: true,
              name: 'ProductList',
              noCache: true
            }
          },
          {
            path: 'viewProduct',
            name: 'viewProduct',
            component: () => import('@/views/Level/products/viewProduct/index.vue'),
            meta: {
              title: t('product.viewProduct'),
              hidden: true,
              name: 'ProductList',
              noCache: true
            }
          },
          {
            path: 'release-sku',
            name: 'ReleaseSku',
            component: () => import('@/views/Level/products/release/Sku.vue'),
            meta: {
              title: t('product.releaseProduct'),
              hidden: true,
              name: 'ProductList',
              noCache: true
            }
          }
        ]
      }
    ]
  },
  {
    path: '/apiKey',
    name: 'ApiKey',
    component: Layout,
    meta: {
      title: t('router.apiKey'),
      icon: 'svgApiKey'
    },
    children: [
      {
        path: 'List',
        name: 'apiKeyList',
        component: () => import('@/views/apiKey/list.vue'),
        meta: {
          title: t('apiKey.list'),
          name: 'apiKeyList'
        }
      },
      {
        path: 'logs',
        name: 'apiKeyLogs',
        component: () => import('@/views/apiKey/logs.vue'),
        meta: {
          title: t('apiKey.log'),
          name: 'apiKeyLogs'
        }
      },
      {
        path: 'doc',
        name: 'apiKeyDoc',
        component: () => import('@/views/apiKey/doc.vue'),
        meta: {
          title: t('apiKey.doc'),
          name: 'apiKeyDoc'
        }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  strict: true,
  routes: constantRouterMap as RouteRecordRaw[],
  scrollBehavior: () => ({ left: 0, top: 0 })
})

export const resetRouter = (): void => {
  const resetWhiteNameList = ['Redirect', 'Login', 'NoFind', 'Root']
  router.getRoutes().forEach((route) => {
    const { name } = route
    if (name && !resetWhiteNameList.includes(name as string)) {
      router.hasRoute(name) && router.removeRoute(name)
    }
  })
}

export const setupRouter = (app: App<Element>) => {
  app.use(router)
}

export default router
